import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/** Parse stored criteria date/timestamp string into a local Date (or null). */
export function parseCriteriaDateValue(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
  if (m) {
    return new Date(
      Number(m[1]),
      Number(m[2]) - 1,
      Number(m[3]),
      Number(m[4] || 0),
      Number(m[5] || 0),
      Number(m[6] || 0)
    );
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Format a Date for SQL DATE / TIMESTAMP literals used by segment criteria. */
export function formatCriteriaDateValue(date, family) {
  if (!date || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  if (family === 'date') return `${y}-${mo}-${day}`;
  const h = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  const sec = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${mo}-${day} ${h}:${mi}:${sec}`;
}

/**
 * Calendar value input for date / timestamp segment criteria.
 * Empty values default to today.
 * @param {'date' | 'timestamp'} family
 */
const CriteriaDateValue = ({
  value,
  onChange,
  family = 'date',
  className = 'criteria-value',
  placeholder,
}) => {
  const isTimestamp = family === 'timestamp';
  const selected = parseCriteriaDateValue(value) || new Date();

  useEffect(() => {
    if (!String(value || '').trim()) {
      onChange(formatCriteriaDateValue(new Date(), family));
    }
    // Seed empty fields to today on mount / when column family changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- avoid re-seeding on every parent render
  }, [family]);

  return (
    <DatePicker
      selected={selected}
      onChange={(date) =>
        onChange(formatCriteriaDateValue(date || new Date(), family))
      }
      showTimeSelect={isTimestamp}
      timeIntervals={15}
      timeCaption="Time"
      dateFormat={isTimestamp ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'}
      placeholderText={placeholder || (isTimestamp ? 'Select date & time' : 'Select date')}
      isClearable
      className={className}
      wrapperClassName="criteria-datepicker-wrap"
      calendarClassName="criteria-datepicker-calendar"
      popperClassName="criteria-datepicker-popper"
      popperPlacement="bottom-start"
      withPortal
    />
  );
};

export default CriteriaDateValue;
